export enum CurlErrorCodesEnum {
    urlMalformat = 3,
    couldNotResolveHost = 6,
    couldNotConnect = 7,
    remoteAccessDenied = 9,
    ftpAcceptTimeout = 12,
    cantGetHost = 15,
    outOfMemory = 27,
    timeout = 28,
    fileSizeExceeded = 63,
    sslFailed = 64,
    remoteDiskFull = 70,
}
